import client from "./client";

export const sendSms = async (data) => {
  return await client({
    url: `/auth/sms/send`,
    method: "post",
    data,
  });
};

export const validateSms = async (data) => {
  return await client({
    url: `/auth/sms/validate`,
    method: "post",
    data,
  });
};
